import {axiosConfigOld as axios} from "../../../utils/axios";

let url = '/graphql/main'

export const createEducationOrder = ({ user_id, is_entrant }:any) => axios.post(url, {
  query: `
    mutation{
      addEducationOrder(${user_id ? `user_id: ${user_id}` : ``} ${is_entrant ? `,is_entrant: ${is_entrant}` : ``}){
        id
        user_id
        lang
        country
        education_form
        status
      }
    }
  `
})

export const fetchChangeEducationOrder = (body:any) => axios.post(url, {
  query: `
    mutation {
    changeEducationOrder( id: ${body.id} ${body.iin_check ? `, iin_check: ${body.iin_check}` : ''}
    ${body.iin_entrant ?
    `,declarant_type: "${body.declarant_type}",
      is_entrant: ${body.is_entrant},
      birthday_entrant: "${body.birthday_entrant ? body.birthday_entrant : ""}",
      birthday_parent: "${body.birthday_parent ? body.birthday_parent : ""}",
      iin_parent: "${body.iin_parent ? body.iin_parent : ''}",
      parent_surname: "${body.parent_surname ? body.parent_surname : ''}",
      parent_name: "${body.parent_name ? body.parent_name : ''}",
      parent_patronymic_entrant: "${body.parent_patronymic_entrant ? body.parent_patronymic_entrant : ''}",
      iin_entrant: "${body.iin_entrant}",
      surname_entrant: "${body.surname_entrant}",
      name_entrant: "${body.name_entrant}",
      patronymic_entrant: "${body.patronymic_entrant ? body.patronymic_entrant : ''}",
      declarant_status: "${body.declarant_status}",
      declarant_address: "${body.declarant_address}",
      phone_entrant: "${body.phone_entrant}",
      email_entrant: "${body.email_entrant}",
      base_education: "${body.base_education}",
      child_invalid: "${body.child_invalid ? body.child_invalid : 2}",
      quota: "${body.quota ? body.quota : 2}",
      invalid1and2: "${body.invalid1and2 ? body.invalid1and2 : 2}",
      vov: "${body.vov ? body.vov : 2}",
      village_soc_ek: "${body.village_soc_ek ? body.village_soc_ek : 2}",
      faces_kaz_nac_without_rk: "${body.faces_kaz_nac_without_rk ? body.faces_kaz_nac_without_rk : 2}",
      conscript: "${body.conscript ? body.conscript : 2}",
      children_without_parent: "${body.children_without_parent ? body.children_without_parent : 2}",
      village_rk: "${body.village_rk ? body.village_rk : 2}",
      children_many: "${body.children_many ? body.children_many : 2}",
      family_half: "${body.family_half ? body.family_half : 2}",
      family_with_invalid: "${body.family_with_invalid ? body.family_with_invalid : 2}",
      hostel: "${body.hostel ? body.hostel : 2}",
      social_help: "${body.social_help ? body.social_help : 2}",
      country: "${body.country}",
      school: "${body.school ? body.school : ''}",
      region: "${body.region ? body.region : ''}",
      district: "${body.district ? body.district : ''}",
      series_certificate: "${body.series_certificate ? body.series_certificate : ''}",
      number_certificate: "${body.number_certificate ? body.number_certificate : ''}"
    ` : body.education_form ?
      `, education_form: "${body.education_form}",
      pay_form: "${body.pay_form}",
      education_type: "${body.education_type}",
      ${body.entrantCollegeId ? `college_id: "${body.entrantCollegeId}"` : ``}`
      : body.receipt_pdf_url ?
        `, status: "${body.status}", receipt_pdf_url: "${body.receipt_pdf_url}"`
        : body.decline_reason ?
          `, status: "${body.status}", decline_reason: "${body.decline_reason}"`
          : body.status ?
            `, status: "${body.status}"  `
            : ''}
    ){
      status
      id
      user_id
      education_form
      pay_form
      birthday_entrant
      birthday_parent
      education_type
      declarant_type
      iin_parent
      parent_surname
      parent_name
      parent_patronymic_entrant
      iin_entrant
      surname_entrant
      name_entrant
      patronymic_entrant
      declarant_status
      declarant_address
      phone_entrant
      email_entrant
      base_education
      child_invalid
      quota
      invalid1and2
      vov
      village_soc_ek
      faces_kaz_nac_without_rk
      children_without_parent
      village_rk
      children_many
      family_half
      family_with_invalid
      hostel
      social_help
      enbek
      conscript
      country
      region
      district
      school
      series_certificate
      number_certificate
      
      receipt_pdf_url
      
      selectedSpecialities{
        id
        education_order_id
        speciality_id
        qualification_id
        college_id
        priority
        status
        language_of_education
  
        speciality{
          caption
          code
        }
        
        raging{
          status
        }
  
        qualification{
          caption
          code
        }
  
        college{
          name
        }
      }
      
      docs{
        id
        type
        name
        url
      }
    }
  }
  `

  //step two: enbek: "${body.enbek}",
})

export const checkIIN = (iin:number) => axios.post(url, {
  query: `
    {
      checkIin(iin: "${iin}")
    }
  `
})

export const checkEmail = (email:string) => axios.post(url, {
  query: `
    {
      checkEmail(email: "${email}")
    }
  `
})

export const fetchLanguagesForSpecialitiesForm = () => axios.post(url, {
  query: `
  {
    languages{
      id
      caption
    }
  }
  `
})

export const fetchDataForSpecialitiesFormV2 = (body:any) => axios.post(url, {
  query: `
    {
      languages{
        id
        caption
      }
    
      profilesWithChildren(type: ${body.type}, ${(body.profile_type || body.profile_type === 0) ? `profile_type: ${body.profile_type}` : ''}){
        id
        caption
        level
        specialities{
          id
          caption
          level
          code
          profile_type
          qualifications{
            id
            level
            caption
            code
            colleges{
              id
              name
            }
          }
        }
      }
    }
  `
})

export const fetchCollegesWithQualification = (body:any) => axios.post(url, {
  query: `
    {
      qualificationColleges(
        qualification_id: ${body.qualificationId},
        education_form: ${body.educationForm},
        lang: ${body.lang},
        base_education: ${body.baseEducation},
        isPayer: ${body.isPayer}
        ){
            id
            name
      }
    }
  `
})

export const setExamResult = (body:any) => axios.post(url, {
  query: `
    mutation{
      changeSelectedSpeciality(
        id: ${body.id},
        ${body.selected_speciality_id ? `selected_speciality_id: ${body.selected_speciality_id}` : ``}
        ${body.interview_result
    ? `interview_result: ${body.interview_result},`
    : body.psychometric_result
      ? `psychometric_result: ${body.psychometric_result},`
      : body.status
        ? `status: "${body.status}",`
        : ``}
      ){
        id
        speciality_id
        qualification_id
        college_id
        priority
        status
        interview_result
        psychometric_result
      }
    }
  `
})

export const createSelectedSpeciality = (body:any) => axios.post(url, {
  query: `
  mutation{
    addSelectedSpeciality(
      education_order_id: ${body.educationOrderId},
      speciality_id: ${body.speciality_id},
      qualification_id: ${body.qualification_id},
      lang: ${body.language_id},
      college_id: ${body.college_id},
      ${body.is_entrant ? `is_entrant: true` : ``}
    ){
      id
      speciality{
        caption
        code
      }
      qualification{
        caption
        code
      }
      college{
        name
      }
      language_of_education
      speciality_id
      qualification_id
      college_id
      priority
      status
    }
  }
  
  `
})

export const changeSelectedSpecialityPriority = (body:any) => axios.post(url, {
  query: `
    mutation {
      changeSelectedSpeciality(id: ${body.id}, priority: ${body.priority}){
        id
        priority
      }
    }
  `
})

export const deleteSelectedSpeciality = (id:number) => axios.post(url, {
  query: `
    mutation{
      deleteSelectedSpeciality(id: ${id},){
        id
        speciality_id
        qualification_id
    }
  }
  
  `
})

export const fetchProvinces = () => axios.post(url, {
  query: `
  {
   provinces{
    id
    caption
    regions{
      id
      caption
      schools{
        id
        caption
      }
    }
  }

  }
  `
})

export const getMarks = (education_order_id:any) => axios.post(url, {
  query: `
{
  educationOrder(
     id: ${education_order_id},
  ){
   id
   allRating
   current_college_id
   educationDocument{
      avg_rating
      count
      ratings{
          id
          education_order_id
          count
          rating
          type
      }
    }
     selectedSpecialities{
      id
      college_id
      priority
      status
      statusValidate
      speciality_id
      qualification_id
      language_of_education
      
      speciality{
        caption
        code
      }

      qualification{
        caption
        code
      }

      college{
        name
      }
      profileMarks{
        id
        education_order_id
        speciality_id
        qualification_id
        subject_name
        subject_name_kaz
        rating
        type
        school_subject_id
        author_type
      }
      requiredMarksByLang{
        id
        education_order_id
        speciality_id
        qualification_id
        subject_name
        subject_name_kaz
        rating
        type
        school_subject_id
        author_type
      }
    }
    markList{
      all{
        id
        rating
        type
        subject_name
        author_type
      }

      required{
        id
        rating
        type
        author_type
        subject_name
      }
      commonWithRequired{
        id
        rating
        type
        subject_name
        author_type
      }
      common{
        id
        rating
        type
        subject_name
        author_type
      }
      subCommon{
        id
        rating
        type
        subject_name
        author_type
      }
      profileFromSystem{
        id
        rating
        type
        subject_name
      }
      selectedSpeciality{
        id
        college_id
        qualification{
          id
          caption
          code
        }
        statusValidate
        priority
        college{
          name
        }
        profileMarks{
          id
          rating
          type
          subject_name
          author_type
        }
        speciality_id
        qualification_id
        speciality{
          id
          code
          caption
        }
      }
    }
  }
}
  `
})

export const addDocument = (body:any) => axios.post(url, {
  query: `
    mutation{
      addCustomDocument(education_order_id: ${body.id}, type: "${body.type}", name: "${body.name}", url: "${body.url}"){
        id
        type
        name
        url
      }
    }
  `
})

export const addLessonApi = (body:any) => axios.post(url, {
  query: `
    mutation{
      addOrChangeCustomRating(
        education_order_id: ${body.education_order_id},
        rating: "${body.rating}",
        subject_name: "${body.subject_name}",
        type: "${body.type}",
        author_type: ${body.author_type}
      ){
        id
        subject_name
        type
        rating
        author_type
      }
    }
  `
})

export const addLessonProfile = (body:any) => axios.post(url, {
  query: `
    mutation{
      addOrChangeCustomRating(
        education_order_id: ${body.education_order_id},
        rating: ${body.rating ? `${body.rating}` : null},
        subject_name: "${body.subject_name}",
        speciality_id: ${body.speciality_id},
        qualification_id: ${body.qualification_id},
        type: "${body.type}",
        author_type: ${body.author_type},
        ${body.rating_id ? `rating_id: ${body.rating_id}` : ``}

      ){
        id
        education_order_id
        speciality_id
        qualification_id
        subject_name
        subject_name_kaz
        rating
        type
        school_subject_id
        author_type
      }
    }
  `
})

export const editLesson = (body:any) => axios.post(url, {
  query: `
    mutation{
      addOrChangeCustomRating(
        education_order_id: ${body.education_order_id},
        rating_id: ${body.rating_id},
        rating: ${body.rating ? `${body.rating}` : null},
        selected_speciality_id: ${body.selected_speciality_id}
      ){
        id
        education_order_id
        speciality_id
        qualification_id
        subject_name
        subject_name_kaz
        rating
        type
        school_subject_id
        author_type
      }
    }
  `
})

export const deleteLesson = (id:any) => axios.post(url, {
  query: `
    mutation{
      deleteCustomRating(
        id: ${id},
      ){
        id
        education_order_id
        speciality_id
        qualification_id
        subject_name
        subject_name_kaz
        rating
        type
        school_subject_id
        author_type
      }
    }
  `
})

export const educationDocumentRating = (body: any) => axios.post(url, {
  query: `
  mutation{
    createOrUpdateEducationDocumentRating(
      education_order_id: ${body.education_order_id},
      rating: ${body.rating},
      count: ${body.count},
    ){
      id 
      type
      avg_rating
      avg_count
      rating
      count
    }
  }
  `
})

export const getInfo = (body:any) => axios.post(url, {
  query: `
{
  educationOrder(
     id: ${body.education_order_id},
  ){
    is_entrant
    current_college_id
    id
    user_id
    iin_entrant
    iin_parent
    name_entrant
    surname_entrant
    birthday_entrant
    birthday_parent
    patronymic_entrant
    parent_name
    parent_surname
    parent_patronymic_entrant
    declarant_status
    declarant_type
    status
    
    canEnroll
    hostel

    base_education
    country
    region
    district
    school
    series_certificate
    number_certificate

    declarant_address
    phone_entrant
    email_entrant

    child_invalid
    quota
    invalid1and2
    enbek
    social_help
    vov
    village_soc_ek
    faces_kaz_nac_without_rk
    children_without_parent
    village_rk
    children_many
    family_half
    family_with_invalid
    conscript

    education_form
    pay_form
    education_type
    
    receipt_pdf_url
    decline_reason
    
    source
    
    educationDocument{
      avg_rating
      count
      ratings{
          id
          education_order_id
          count
          rating
          type
      }
    }

    selectedSpecialities{
      id
      education_order_id
      speciality_id
      qualification_id
      college_id
      priority
      status
      language_of_education

      speciality{
        id
        caption
      }

      qualification{
        id
        caption
      }

      college{
        id
        name
      }
      
      availableQualifications{
        id
        caption
      }
      
      requiredMarksByLang{
        id
        rating
        type
        subject_name
      }
      
      raging{
        status
      }
    }
   
    docs{
      id
      type
      name
      url
    }
    
    markList{
      all{
        id
        rating
        type
        subject_name 
        author_type
      }
      common{
        id
        rating
        type
        subject_name
        author_type
      }
      subCommon{
        id
        rating
        type
        subject_name
        author_type
      }
      required{
        id
        rating
        type
        subject_name
      }
      profileFromSystem{
        id
        rating
        type
        subject_name
      }
      selectedSpeciality{
        id
        qualification{
          caption
          code
        }
        profileMarks{
          id
          type
          rating
          subject_name
        }
      }
    }
  }
}
  `
})

export const fetchGroupList = () => axios.post(url, {
  query: `
    {
      groupsReception{
          id
          caption
          caption_kk
        }
        
        reception{
          admins{
            id
            fio
          }
          director{
            id
            fio
          }
          teachers{
            id
            fio
          }
        }

    }
  `
})

export const getStudentIdByEducationOrder = (education_order_id:any) => axios.post(url, {
  query: `
    {
      getStudentIdByEducationOrder(education_order_id:  ${education_order_id})
   }
  `
})

export const addToStudentListApi = (education_order_id:any) => axios.post(url, {
  query: `
    {
      addToStudentList(education_order_id:  ${education_order_id})
   }
  `
})

export const setStatus = (body:any) => axios.post(url, {
  query: `
    mutation{
      changeEducationOrderStatus(
        id: ${body.education_order_id},
        status: "${body.status}",
      ){
        id
        status
      }
    }
  `
})

export const orderCreateApi = (body:any) => axios.post(url, {
  query: `
    mutation{
      addUserOrder(
          selected_speciality_id: ${body.selected_speciality_id}
          ${body.user_id ? `user_id: ${body.user_id},` : ``}
          
          number: "${body.number}",
          date: "${body.date}",
          basis_ru: "${body.basis_ru}",
          basis_kk: "${body.basis_kz}",
          admin_id: ${body.admin_id},
          group_id: ${body.group_id},
          sub_admin_id: ${body.sub_admin_id}
      ){
          id,
          number,
          date,
          type,
          basis{
            ru,
            kk
          },
          variables{
            admin_id,
            sub_admin_id,
            group_id,
            from_group_id,
            to_group_id,
            expulsion_reason,
            new_institution_name,
            other_reason_ru,
            other_reason_kk
          },
          user{
            id,
            fio
          },
          student{
            id
            fio
          }
      }
    }
  `
})

export const leaveStudentApi = (body:any) => axios.post(url, {
  query: `
    mutation{
      academicLeaveStudent(
          student_id: ${body.student_id},
          number: "${body.number}",
          basis_ru: "${body.basis_ru}",
          basis_kk: "${body.basis_kz}",
          admin_id: ${body.admin_id},
          sub_admin_id: ${body.sub_admin_id},
          date: "${body.date}",
      ){
         id,
          user_id,
          number,
          date,
          type,
          basis{
            ru,
            kk
          },
          variables{
            admin_id,
            sub_admin_id,
            group_id,
            from_group_id,
            to_group_id,
            new_institution_name,
            other_reason_ru,
            other_reason_kk
          },
          user{
            id,
            fio
          },
          student{
            id
            fio
          }
      }
    }
  `
})


export const orderEditApi = (body:any) => axios.post(url, {
  query: `
    mutation{
      changeUserOrder(
          id: ${body.id},
          number: "${body.number}",
          basis_ru: "${body.basis_ru}",
          basis_kk: "${body.basis_kz}",
          sub_admin_id: ${body.sub_admin_id}
      ){
          id,
          user_id,
          number,
          date,
          type,
          basis{
            ru,
            kk
          },
          variables{
            admin_id,
            sub_admin_id,
            group_id,
            from_group_id,
            to_group_id,
            expulsion_reason,
            new_institution_name,
            other_reason_ru,
            other_reason_kk
          },
          user{
            id,
            fio
          },
          student{
            id
            fio
          }
      }
    }
  `
})

export const orderViewApi = (id:any) => axios.post(url, {
  query: `
    {
      userOrder(id:  ${id}){
        id,
        user_id,
        number,
        date,
        type,
        description,
        basis{
          ru,
          kk
        },
        variables{
          admin_id,
          sub_admin_id,
          group_id,
          from_group_id,
          to_group_id,
          expulsion_reason,
          new_institution_name,
          other_reason_ru,
          other_reason_kk
        },
        student{
          id
          fio
        },
        user{
          id,
          fio
        }
      }
    }
  `
})

export const fetchExamResult = (body:any) => axios.post(url, {
  query: `
{
  educationOrder(
     id: ${body.education_order_id},
  ){
  id
  base_education
  current_college_id
    selectedSpecialities{
      id
      college_id
      priority
      status
      statusValidate
      speciality_id
      qualification_id
      language_of_education
      
      speciality{
        caption
        code
      }
      
      raging{
        status
      }

      qualification{
        caption
        code
      }

      college{
        name
      }
      
      examTypes{
        id
        field_for_update_result
        is_avail_status
        label
        result
      }
      marksStep3{
        average
        profileMarks{
          id
          education_order_id
          speciality_id
          qualification_id
          subject_name
          subject_name_kaz
          rating
          type
          school_subject_id
          author_type
        }
        requiredMarks{
          id
          education_order_id
          speciality_id
          qualification_id
          subject_name
          subject_name_kaz
          rating
          type
          school_subject_id
          author_type
        }
        requiredMarks{
          id
          education_order_id
          speciality_id
          qualification_id
          subject_name
          subject_name_kaz
          rating
          type
          school_subject_id
          author_type
        }
         examMarks{
          id
          education_order_id
          speciality_id
          qualification_id
          subject_name
          subject_name_kaz
          rating
          type
          school_subject_id
        }
      }
    }
  

  }

}
  `
})

export const declineReason = (body:any) => axios.post(url,{
  query:`
    mutation{
      changeEducationOrder(
        id: ${body.id},
        decline_reason: "${body.decline_reason}"
        ){
          id
          decline_reason
        }
    }
  `
})

export const setSpecialtyStatus = (body:any) => axios.post(url, {
  query: `
    mutation{
      changeSelectedSpecialityStatus(
        id: ${body.id},
        status: "${body.status}",
      ){
        id
        status
      }
    }
  `
})

export const fetchCollegeAndExecutor = (id:any) => axios.post(url, {
  query: `
    {
      educationOrder(id: ${id}) {
        id
        current_college_id
        selectedSpecialities{
          college_id
        }
        college{
          id
          name
          address{
          caption
            country{
              caption
            }
            parent{
              caption
              parent{
                caption
              }
            }
          }
        }
        
        executor{
          id
          phone
          fio
          iin
        }
      }
    }
  `
})

export const getTotalResult = (body:any) => axios.post(url, {
  query: `
{
  educationOrder(
     id: ${body.education_order_id},
  ){
  id
    current_college_id
  selectedSpecialities{
      id
      college_id
      speciality{
        caption
        code
      }
      qualification{
        caption
      }
      language_of_education
      college{
        name
      }
      priority
      status
      
      raging{
        status
      }
    }

  }

}
  `
})

export const setExecutorEgovApplication = (id:any) => axios.post('/graphql/main', {
  query: `
    mutation{
      setExecutor(id: ${id}){
        id
        executor_id
        college_id
      }
    }
  `
})

export const getEntrantApplications = () => axios.post(url, {
  query: `
	{
    getEducationOrdersForEntrant {
	    id
	    status
	    created_at
	    education_form
	    education_type
	  }
	}
  `
})

export const admissionLogApi = (education_order_id:any) => axios.post(url, {
  query: `
    {
      educationOrderHistory(education_order_id:  ${education_order_id}){
        id
        education_order_id
        status
        old_status
        new_status
        created_at
        statusLabel
        label
        executor {
          id
          fio
        }
    }
   }
  `
})

//общий конкурс

//Список специальностей
export const getGeneralContestSpecialitiesList = (base_education:any) => axios.post(url, {
  query: `
  {
    getSpecialityList(base_education: ${base_education}){
      id
      caption
      code
      qualifications{
        id
        caption
      }
    }
  }
  `
})

//Список заявок без квот
export const getGeneralContest = (body:any) => axios.post(url, {
  query: `
	{
		getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
      ){
        selectedSpeciality{
          quota
          id
          language_of_education
          speciality{
            caption
          }
          qualification{
            caption
          }
          transfer{
		        status_confirm
	        }
          priority
          entrant_response
          created_at
        }
        educationOrder{
          surname_entrant
          name_entrant
          patronymic_entrant
          base_education
          phone_entrant
          quota
        }
        id
        status
        koef
        contest_rating
        average_rating
        action
      }
    }
	`
})

//Список заявок с квотами
export const getGeneralContestWithQuotes = (body:any) => axios.post(url, {
  query: `
		{
      invalid1and2:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "invalid1and2"
      ){
				...comparisonFields
      }
      vov:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "vov"
      ){
				...comparisonFields
      }
      village_soc_ek:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "village_soc_ek"
      ){
				...comparisonFields
      }
      faces_kaz_nac_without_rk:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "faces_kaz_nac_without_rk"
      ){
				...comparisonFields
      }
      conscript:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "conscript"
      ){
				...comparisonFields
      }
      children_without_parent:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "children_without_parent"
      ){
				...comparisonFields
      }
      village_rk:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "village_rk"
      ){
				...comparisonFields
      }
      children_many:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "children_many"
      ){
				...comparisonFields
      }
      family_half:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "family_half"
      ){
				...comparisonFields
      }
      family_with_invalid:getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        quota: "family_with_invalid"
      ){
				...comparisonFields
      }
    }
    
    
	fragment comparisonFields on Raging {
	    selectedSpeciality{
	      id
	      created_at
	      entrant_response
	      language_of_education
	      speciality{
	        caption
	      }
	      qualification{
	        caption
	      }
	      transfer{
	        status_confirm
	      }
	      priority
	    }
	    educationOrder{
	      surname_entrant
	      name_entrant
	      patronymic_entrant
	      base_education
	      phone_entrant
	      quota
	    }
	    id
	    status
	    quota
	    koef
	    contest_rating
	    average_rating
	    action
	}
	`
})

export const getGeneralContestWithQuotesNew = (body: any) => axios.post(url, {
  query: `
    {
      getRagingList(
        base_education: ${body.base_education},
        speciality_id: ${body.speciality_id},
        ${body.qualification_id ? `qualification_id: ${body.qualification_id},` : ``}
        quota: "invalid1and2"
      ){
        ...comparisonFields
      }
    }

    fragment comparisonFields on Raging {
      quota
      selectedSpeciality {
        id
        created_at
        entrant_response
        language_of_education
        speciality {
          caption
        }
        qualification {
          caption
        }
        transfer {
          status_confirm
        }
        priority
      }
      educationOrder {
        surname_entrant
        name_entrant
        patronymic_entrant
        base_education
        phone_entrant
        quota
      }
      id
      status
      koef
      contest_rating
      average_rating
      action
    }
  `,
});

export const changeEntrantResponse = (body:any) => axios.post(url, {
  query: `
		mutation{
			changeEntrantResponse(selected_speciality_id: ${body.selected_speciality_id}, response: ${body.response}){
		    id
		    entrant_response
		    raging{
			    status
		    }
	  }
	}
	`
})

export const getCollegeListToTransfer = (speciality_id:any) => axios.post(url, {
  query: `
		{
			getCollegeListTransfer(speciality_id: ${speciality_id}){
				id
				name
			}
		}
	`
})

export const entrantTransferToOtherCollege = (body:any) => axios.post(url, {
  query: `
		mutation{
			doTransfer(selected_speciality_id: ${body.selected_speciality_id}, college_id: ${body.college_id}){
		    id
		    selected_speciality_id
		    from_college_id
		    to_college_id
		    status_confirm
	  }
	}
	`
})


//entrant info
export const getEntrantInfoData = () => axios.post(url, {
  query: `
    {
      listOfRating {
        contest_rating,
        average_rating,
        priority,
        base_education,
        name_entrant,
        surname_entrant,
        patronymic_entrant,
        college{
            name
        },
        speciality{
            caption,
            code
        },
        qualification{
            caption,
            code
        },
      }
    }
  `
})


//sign xml parent/entrant
export const getEducationOrderXML = ({education_order_id}:any) => axios.get("/eds/get-xml", {
  params: {
    education_order_id
  }
})

export const postEducationOrderXML = ({education_order_id, xml}:any) => axios.post("/eds/generate-xml", xml, {
  params: {
    education_order_id
  }
})